var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, Tooltip } from '@patternfly/react-core';
import React from 'react';
;
export const ActionButton = (_a) => {
    var { tooltipProps } = _a, buttonProps = __rest(_a, ["tooltipProps"]);
    const tooltipRef = React.useRef();
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, Object.assign({ "aria-describedby": tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.id, innerRef: tooltipRef }, buttonProps)),
        tooltipProps ? React.createElement(Tooltip, Object.assign({}, tooltipProps, { triggerRef: tooltipRef })) : null));
};
export default ActionButton;
